import { gql } from '@apollo/client';

export const updateMachine = gql`
  mutation updateMachine($input: MachineUpdateInput!) {
    updateMachine(input: $input) {
      alias
      facility
      object
    }
  }
`;

export const deleteMachine = gql`
  mutation MachineDelete($input: MachineDeleteInput!) {
    deleteMachine(input: $input) {
      id
    }
  }
`;
